/** 문구 토큰 치환 — 확인창·토스트 문구의 `{count}` = 표 선택 수, `{<컬럼>}` = 선택 행의 그 컬럼 값
 *  (중복 제거 · 여럿이면 "첫 값 외 n건" · 키는 대소문자 무시: 데모 컬럼 `DELVNO` ↔ 문구 `{delvNo}`). 값이 없으면 빈 문자열.
 *  종전엔 {count} 만 치환하고 나머지는 글자 그대로/빈 문자열이라, 삭제 확인 문구가 "어느 입고번호가 지워지는지" 를 말할 수 없었다
 *  (moms-fe #770 봇 리뷰 2026-09-18 — dev MESSAGES.deleteContent 는 입고번호를 안내한다).
 *  **산출물도 이 파일을 쓴다**(동반 파일, 4단계 2026-10-08) — 종전엔 codegen 이 같은 식을 텍스트로 적어 내 두 벌이었다.
 *  산출물에 실리므로 react·DS import 0 을 지킨다. `Array.from(new Set(...))` 는 취향이 아니라 조건이다 —
 *  dev tsconfig 가 es5 인 레포(mwms-fe·mss-o4o-fe)에서 Set 스프레드가 TS2802 다(2026-10-06 실측). */
export function fillSelectionTokens(s: string, count: number, rows: Record<string, unknown>[]): string {
  return s.replace(/\{(\w+)\}/g, (_m, k: string) => {
    if (k === 'count') return String(count)
    const first = rows[0]
    const key = first ? (k in first ? k : Object.keys(first).find((c) => c.toLowerCase() === k.toLowerCase())) : undefined
    if (!key) return ''
    // 여러 값 = "첫 값 외 n건"(n = 나머지 고유 값 수) — dev 확정 스펙(moms-fe MESSAGES.deleteContent, 사용자 확정 2026-09-10)과 같은 표기.
    const vals = Array.from(new Set(rows.map((r) => r[key]).filter((v) => v != null && v !== '').map(String)))
    return vals.length > 1 ? `${vals[0]} 외 ${vals.length - 1}건` : (vals[0] ?? '')
  })
}
